// extracted by mini-css-extract-plugin
module.exports = {"shareholders":"Datablock_ShareHolders_shareholders__eXA15"};